module.exports = __webpack_public_path__ + "img/slide3.3c26f5f9.jpg";